import { useEffect, useRef } from 'react';
import { setupCanvas, drawWheel, runSpin } from '../../utils/wheel';

// spin = { id, win, fast }. Naya spin aate hi animation start hoti hai.
export default function WheelOverlay({ show, spin, onLand, onDone }) {
  const wheelRef = useRef(null);
  const ballRef = useRef(null);
  const ballCtx = useRef(null);
  const cb = useRef({ onLand, onDone });

  useEffect(() => { cb.current = { onLand, onDone }; }, [onLand, onDone]);

  useEffect(() => {
    drawWheel(setupCanvas(wheelRef.current));
    ballCtx.current = setupCanvas(ballRef.current);
  }, []);

  useEffect(() => {
    if (!spin) return undefined;
    let cancel = null;
    const t = setTimeout(() => {
      cancel = runSpin({
        wheelEl: wheelRef.current,
        ballCtx: ballCtx.current,
        win: spin.win,
        fast: spin.fast,
        onLand: () => cb.current.onLand(),
        onDone: () => cb.current.onDone(),
      });
    }, 500);
    return () => { clearTimeout(t); if (cancel) cancel(); };
  }, [spin]);

  return (
    <>
      <div className={`overlay${show ? ' show' : ''}`} />
      <div className={`wheel-box${show ? ' show' : ''}`}>
        <canvas id="wheel" ref={wheelRef} />
        <canvas id="ball" ref={ballRef} />
      </div>
    </>
  );
}
